import camelCaseKeysDeep from 'camelcase-keys-deep';
import axios from './axios';
import type { WorkSession, WorkSessionTablePayload } from '../types';

export const checkIn = (sessionType: 'remote' | 'remote_sick' | 'sick' | 'business_trip', date?: string): Promise<{ data: WorkSession }> => {
  return axios.post('/work_sessions', {
    session_type: sessionType,
    date
  }).then(response => ({
    data: camelCaseKeysDeep(response.data)
  }));
};

export const getWorkSessions = (startDate?: string, endDate?: string, userId?: number): Promise<{ data: Array<WorkSession> }> => {
  return axios.get('/work_sessions', {
    params: {
      start_date: startDate,
      end_date: endDate,
      user_id: userId
    }
  }).then(response => ({
    data: camelCaseKeysDeep(response.data)
  }));
};

export const getWorkSessionsTable = (
  startDate?: string,
  endDate?: string
): Promise<{ data: WorkSessionTablePayload }> => {
  return axios.get('/work_sessions/users', {
    params: {
      start_date: startDate,
      end_date: endDate
    }
  }).then(response => ({
    data: camelCaseKeysDeep(response.data)
  }));
};
